import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import ProductsTabs_ from '../../tabs/ProductsTabs';
import PromoteTabs_ from '../../tabs/PromoteTabs';
import { Heading, SubHeading } from '../../typography';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.white};
  text-align: center;
  display: flex;
  position: relative;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  max-width: 950px;
  margin: 70px auto 80px auto;
  padding: 0 20px;

  ${Heading} {
    margin-bottom: 20px;
  }

  @media screen and (${largeTabletMax}) {
    ${Heading} {
      margin-bottom: 15px;
      font-size: 28px;
    }

    ${SubHeading} {
      font-size: 20px;
    }
  }
`;

const tabs = css`
  width: 100%;
  max-width: fit-content;
  position: absolute;
  bottom: -20px;
  right: 50%;
  transform: translateX(50%);
`;

export const PromoteTabs = styled(PromoteTabs_)`
  ${tabs}
`;

export const ProductsTabs = styled(ProductsTabs_)`
  ${tabs}
`;
